import {
    apiRequest,
    provinsiCreate,
} from "../../../../../services/adapters/master/provinsiService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", provinsiCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository